<div class="tabbable__body rounded-top-right no-margin">
  <h3>
    Här kan du administrera maxuttag för dayparts
  </h3>

  @if (show.withdrawalLimitsHaveChanged) {
    <import-warning></import-warning>
  }
  <dot-loader [visibility]="show.updatingEstimates"></dot-loader>

  <div class="container">
    <div class="left-item">
      @if (show.isEditing) {
        <button
          class="button primary"
          (click)="save()"
          [disabled]="daypartWithdrawalLimits.invalid"
        >
          Spara
        </button>
        <button class="link" (click)="cancelEditing()">
          Avbryt redigering
        </button>
      } @else {
        <button class="button primary" (click)="setEditing(true)">
          Redigera maxuttag
        </button>
      }
    </div>
    <div class="right-item">
      <div class="display--flex">
        <div class="dropdown filter-dropdown">
          <woo-dropdown
            [items]="dayparts"
            [(ngModel)]="selectedDaypart"
            name="selectedDaypart"
            inputId="select-daypart"
            labelText="Filtrera på daypart"
            notFoundText="Inga dayparts hittades."
            [clearable]="true"
          ></woo-dropdown>
        </div>

        @if (productFormats?.length > 1) {
          <div class="dropdown filter-dropdown margin-left--2x">
            <woo-dropdown
              [items]="productFormats"
              [(ngModel)]="selectedProductFormat"
              name="selectedProductFormat"
              inputId="select-product-format"
              labelText="Filtrera på Placering"
              [labelTransform]="translateProductFormat"
              notFoundText="Inga Placeringar hittades."
              [clearable]="true"
            ></woo-dropdown>
          </div>
        }

        @if (publishers?.length > 1) {
          <div class="dropdown filter-dropdown margin-left--2x">
            <woo-dropdown
              [items]="publishers"
              [(ngModel)]="selectedPublisher"
              name="selectedPublisher"
              inputId="select-publisher"
              labelText="Filtrera på Publicist"
              notFoundText="Inga publicister hittades."
              [clearable]="true"
            ></woo-dropdown>
          </div>
        }
      </div>
    </div>
  </div>
  <div class="sticky-header">
    <h3>Tillgängliga dayparts</h3>
  </div>

  <table
    class="table table-woo table--info table--hover width--100"
    ngForm
    #daypartWithdrawalLimits="ngForm"
  >
    <thead class="sticky-table-head">
      <tr>
        <th [colSpan]="staticFields"></th>
        <th class="text-centered" colspan="3">Maxuttag</th>
      </tr>
      <tr>
        @for (header of tableHeaders; track $index) {
          <th class="text--thin capitalize--first-letter">
            {{ header }}
          </th>
        }
      </tr>
    </thead>

    @if (!show.loading) {
      <tbody>
        @for (
          row of daypartsRows;
          let index = $index;
          track $index
        ) {
          <tr [hidden]="!rowVisible(row)">
            <td class="text--thin vertical-align--middle">
              <span>{{ row.publisher }}</span>
            </td>
            <td class="text--thin vertical-align--middle">
              <span>{{ translateProductFormat(row.productFormat) }}</span>
            </td>
            <td class="text--thin vertical-align--middle">
              <span>{{ row.daypart }}</span>
            </td>
            <td class="text--thin vertical-align--middle">
              <span>{{ row.daypartDescription }}</span>
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>
                  {{ row.withdrawalLimitsPreroll | percent: '1.0-3' }}
                </span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-sharesPreroll"
                    [(ngModel)]="
                      getDaypartWithdrawalLimits(row.productFormatId)[
                        row.daypartId
                      ].preroll
                    "
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="
                      includedProductFormatSlotTypes[row.productFormatId]
                        .preroll
                    "
                    [disabled]="
                      !includedProductFormatSlotTypes[row.productFormatId]
                        .preroll
                    "
                  />
                </div>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>
                  {{ row.withdrawalLimitsMidroll | percent: '1.0-3' }}
                </span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-sharesMidroll"
                    [(ngModel)]="
                      getDaypartWithdrawalLimits(row.productFormatId)[
                        row.daypartId
                      ].midroll
                    "
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="
                      includedProductFormatSlotTypes[row.productFormatId]
                        .midroll
                    "
                    [disabled]="
                      !includedProductFormatSlotTypes[row.productFormatId]
                        .midroll
                    "
                  />
                </div>
              }
            </td>

            <td class="vertical-align--middle">
              @if (!show.isEditing) {
                <span>
                  {{ row.withdrawalLimitsPostroll | percent: '1.0-3' }}
                </span>
              } @else {
                <div class="input__container">
                  <input
                    name="row-{{ index }}-sharesPostroll"
                    [(ngModel)]="
                      getDaypartWithdrawalLimits(row.productFormatId)[
                        row.daypartId
                      ].postroll
                    "
                    wooPercentFormatter
                    [wooMinValidator]="0"
                    [wooMaxValidator]="1"
                    [required]="
                      includedProductFormatSlotTypes[row.productFormatId]
                        .postroll
                    "
                    [disabled]="
                      !includedProductFormatSlotTypes[row.productFormatId]
                        .postroll
                    "
                  />
                </div>
              }
            </td>
          </tr>
        }
      </tbody>
    }
  </table>

  <dot-loader [visibility]="show.loading" [large]="true"></dot-loader>

  @if (show.isEditing) {
    <div class="margin-top--2x">
      <button
        class="button primary"
        (click)="save()"
        [disabled]="daypartWithdrawalLimits.invalid"
      >
        Spara
      </button>
      <button class="link" (click)="cancelEditing()">
        Avbryt redigering
      </button>
    </div>
  }
</div>
